import { IconSize } from "../../classes/enums/ButtonEnum";
import { getIconSizeClass } from "../../classes/utils/UiUtils";
import { iconMapping } from "../../config/iconConfig";
import "./SettingsButton.css";

const SettingsButton = ({
  label,
  icon,
  iconSize = IconSize.MEDIUM,
  onClick,
}) => {
  const IconComponent = iconMapping[icon];
  return (
    <div className="setting-button" onClick={onClick}>
      <span>{label}</span>
      {IconComponent && (
        <div className={getIconSizeClass(iconSize)}>
          <IconComponent />
        </div>
      )}
    </div>
  );
};

export default SettingsButton;
